// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"dq-z","breadcrumbForward":"eq-z","breadcrumbBack":"fq-z","selected":"gq-z"};